import { Component, OnInit, Input } from '@angular/core';
import { KomitentEmail } from '../komitent-email/komitent-email';
import { List } from 'immutable';
import { KomitentTelefon } from '../komitent-telefon/komitent-telefon';
import { KomitentZrc } from '../komitent-zrc/komitent-zrc';
import { KomitentUvozNBS } from './komitent-uvoz-nbs';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseDataService, BaseCommonComponent, UserService, ModalService, CommonService, NotificationService } from 'yt-ng-framework';
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { KomitentView } from '../komitent-view';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-komitent-uvoz-nbs',
  templateUrl: './komitent-uvoz-nbs.component.html'
})
export class KomitentUvozNbsComponent extends BaseCommonComponent implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected activeModal: NgbActiveModal,
    protected baseDataService: BaseDataService,
    // protected notificationService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService,
    protected userService: UserService,
    protected modalService: ModalService
  ) { 
    super(activatedRoute, userService, baseDataService, translateService, modalService,toastrService);

  }

  emaili: List<KomitentEmail>;
  telefoni: List<KomitentTelefon>;
  ziroracuni: List<KomitentZrc>;
  itemsKomitent: List<KomitentUvozNBS>;

  @Input() Parameters;

  // baseFormGroup : FormGroup = new FormGroup({
  //   EmailControl : new FormControl(''),
  //   TelefonControl : new FormControl(''),
  //   ZiroracunControl : new FormControl(''),
  //   Naziv : new FormControl(''),
  //   SNaziv : new FormControl(''),
  //   Pib : new FormControl(''),
  //   MaticniBroj : new FormControl(''),
  //   Adresa : new FormControl(''),
  //   MestoID : new FormControl(''),
  //   Web : new FormControl('')
  // })

  gridEmailColumns = [];
  gridTelefonColumns = [];
  gridZiroracunColumns = [];

  itemEmail: KomitentEmail;
  itemTelefon: KomitentTelefon;
  itemZrc: KomitentZrc;

  submitted : boolean = false;
  loading : boolean = false;

  ngOnInit() {
    this.baseFormGroup = new FormGroup({
      EmailControl : new FormControl(''),
      TelefonControl : new FormControl(''),
      ZiroracunControl : new FormControl(''),
      Naziv : new FormControl(''),
      SNaziv : new FormControl(''),
      Pib : new FormControl(''),
      MaticniBroj : new FormControl(''),
      Adresa : new FormControl(''),
      MestoID : new FormControl(''),
      Web : new FormControl(''),
      Jbkjs: new FormControl('')
    })

    this.addValidatorToFc("Naziv",Validators.required,'required',"KOMITENT.NAZIV.VALIDATION.REQUIRED");
    this.addValidatorToFc("Naziv", Validators.maxLength(200), 'maxlength', 'KOMITENT.NAZIV.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("SNaziv",Validators.required,'required',"KOMITENT.SNAZIV.VALIDATION.REQUIRED");
    this.addValidatorToFc("SNaziv", Validators.maxLength(100), 'maxlength', 'KOMITENT.SNAZIV.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("Pib",Validators.required,'required',"KOMITENT.PIB.VALIDATION.REQUIRED");
    this.addValidatorToFc("Pib", Validators.maxLength(9), 'maxlength', 'KOMITENT.PIB.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("MaticniBroj",Validators.required,'required',"KOMITENT.MATICNIBROJ.VALIDATION.REQUIRED");
    this.addValidatorToFc("MaticniBroj", Validators.maxLength(8), 'maxlength', 'KOMITENT.MATICNIBROJ.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("Adresa",Validators.required,'required',"KOMITENT.ADRESA.VALIDATION.REQUIRED");
    this.addValidatorToFc("Adresa", Validators.maxLength(200), 'maxlength', 'KOMITENT.ADRESA.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("MestoID",Validators.required,'required',"KOMITENT.MESTO.VALIDATION.REQUIRED");
    // this.addValidatorToFc("Zrc", Validators.required, 'required', 'KOMITENTZRC.ZRC.VALIDATION.REQUIRED');
    // this.addValidatorToFc("Zrc", Validators.pattern('^[0-9]{3}-[0-9]{1,13}-[0-9]{2}$'), 'pattern', 'KOMITENTZRC.ZRC.VALIDATION.PATTERN');
    // this.addValidatorToFc("Zrc", ytKontrolaPoModulu97, 'zrcControlNumbers', 'FW.KONTROLAPOMODULU.VALIDATION.MODUL97');
    this.addValidatorToFc("Jbkjs", Validators.maxLength(5), 'maxlength', 'KOMITENT.JBKJS.VALIDATION.MAXLENGTH');


    this.itemsKomitent = this.Parameters[0].Value;
    this.baseFormGroup.patchValue({Naziv : this.itemsKomitent[0].Naziv});
    this.baseFormGroup.get('Naziv').updateValueAndValidity();
    this.baseFormGroup.patchValue({SNaziv : this.itemsKomitent[0].SNaziv != '' ? this.itemsKomitent[0].SNaziv : this.itemsKomitent[0].Naziv});
    this.baseFormGroup.get('SNaziv').updateValueAndValidity();
    this.baseFormGroup.patchValue({Pib : this.itemsKomitent[0].Pib});
    this.baseFormGroup.get('Pib').updateValueAndValidity();
    this.baseFormGroup.patchValue({MaticniBroj : new CommonService().PadLeft(this.itemsKomitent[0].MaticniBroj, "0", 8)});
    this.baseFormGroup.get('MaticniBroj').updateValueAndValidity();
    this.baseFormGroup.patchValue({Adresa : this.itemsKomitent[0].Adresa});
    this.baseFormGroup.get('Adresa').updateValueAndValidity();
    this.baseFormGroup.patchValue({MestoID : this.itemsKomitent[0].MestoID});
    this.baseFormGroup.get('MestoID').updateValueAndValidity();
    this.baseFormGroup.patchValue({Web : this.itemsKomitent[0].Web});
    this.baseFormGroup.get('Web').updateValueAndValidity();   
    this.baseFormGroup.patchValue({Jbkjs : this.itemsKomitent[0].Jbkjs});
    this.baseFormGroup.get('Jbkjs').updateValueAndValidity();  
    this.emaili = this.itemsKomitent[0].Emaili;
    this.telefoni = this.itemsKomitent[0].Telefoni;
    this.ziroracuni =  this.itemsKomitent[0].ZiroRacuni;

    this.gridEmailColumns = this.Parameters[1].Value;
    this.gridTelefonColumns = this.Parameters[2].Value;
    this.gridZiroracunColumns = this.Parameters[3].Value;

  }

  Close(){
    this.activeModal.close();
  }

  async Save(){
    this.submitted = true;  
    if (this.baseFormGroup.valid) {
      this.loading = true;
      this.itemsKomitent[0].Naziv = this.baseFormGroup.get('Naziv').value;
      this.itemsKomitent[0].SNaziv = this.baseFormGroup.get('SNaziv').value;
      this.itemsKomitent[0].Pib = this.baseFormGroup.get('Pib').value;
      this.itemsKomitent[0].MaticniBroj = this.baseFormGroup.get('MaticniBroj').value;
      this.itemsKomitent[0].Adresa = this.baseFormGroup.get('Adresa').value;
      this.itemsKomitent[0].MestoID = this.baseFormGroup.get('MestoID').value;
      this.itemsKomitent[0].Web = this.baseFormGroup.get('Web').value;
      this.itemsKomitent[0].JBKJS = this.baseFormGroup.get('Jbkjs').value;

      let brojGlavnihTelefona : number = null;
      let brojGlavnihZiroRacuna : number = null;

      if (this.itemsKomitent[0].Telefoni != null)
        brojGlavnihTelefona = this.checkBrojGlavnih(this.itemsKomitent[0].Telefoni);
      
      if (this.itemsKomitent[0].ZiroRacuni != null)
        brojGlavnihZiroRacuna = this.checkBrojGlavnih(this.itemsKomitent[0].ZiroRacuni);

      if (this.itemsKomitent[0].Telefoni != null && brojGlavnihTelefona > 1 || brojGlavnihTelefona == 0){
        this.translateService.get(['KOMITENT.UVOZNBS.VALIDATION.TITLE', 'KOMITENT.UVOZNBS.TELEFON.VALIDATION.CONTENT'])
          .subscribe(translate => {
            // this.notificationService.warn(translate['KOMITENT.UVOZNBS.VALIDATION.TITLE'], translate['KOMITENT.UVOZNBS.TELEFON.VALIDATION.CONTENT']);
            this.toastrService.warning(translate['KOMITENT.UVOZNBS.VALIDATION.TITLE'], translate['KOMITENT.UVOZNBS.TELEFON.VALIDATION.CONTENT']);
            
          });
          this.submitted = false;
          this.loading = false;
          return false;
        
      }

      if (this.itemsKomitent[0].ZiroRacuni != null && brojGlavnihZiroRacuna > 1 || brojGlavnihZiroRacuna == 0){
        this.translateService.get(['KOMITENT.UVOZNBS.VALIDATION.TITLE', 'KOMITENT.UVOZNBS.ZIRORACUN.VALIDATION.CONTENT'])
          .subscribe(translate => {
            // this.notificationService.warn(translate['KOMITENT.UVOZNBS.VALIDATION.TITLE'], translate['KOMITENT.UVOZNBS.ZIRORACUN.VALIDATION.CONTENT']);
            this.toastrService.warning(translate['KOMITENT.UVOZNBS.VALIDATION.TITLE'], translate['KOMITENT.UVOZNBS.ZIRORACUN.VALIDATION.CONTENT']);
          });
          this.submitted = false;
          this.loading = false;
          return false;
      }

      if (this.checkGridData(this.itemsKomitent[0].Emaili, this.gridEmailColumns, true)
        && this.checkGridData(this.itemsKomitent[0].Telefoni, this.gridTelefonColumns, true)
        && this.checkGridData(this.itemsKomitent[0].ZiroRacuni, this.gridZiroracunColumns, true)){    
          let noviID : number = -1;
          if(this.itemsKomitent[0].ID == -1){
            await new Promise<void>((resolve, reject) =>{
            this.baseDataService.Post("Komitent","post",this.itemsKomitent[0],null)
            .subscribe((data : KomitentView[])=>{
              noviID = data["ID"];
              this.itemsKomitent[0].ID = noviID;
              resolve();
            },
            error =>{
              this.translateService.get(['KOMITENT.UVOZNBS.INSERTKOMITENT.ERROR.TITLE'])
              .subscribe(translate => {
                // this.notificationService.warn(translate['KOMITENT.UVOZNBS.INSERTKOMITENT.ERROR.TITLE'], error.error);
                this.toastrService.warning(translate['KOMITENT.UVOZNBS.INSERTKOMITENT.ERROR.TITLE'], error.error);
              });
              this.submitted = false;
              this.loading = false;              
              return false;
            })
          })
        }
        else{
          await new Promise<void>((resolve, reject) =>{
            this.baseDataService.Post("Komitent","post",this.itemsKomitent[0],null)
            .subscribe(()=>{
              resolve();
            })
            
          })
        }
        if (this.itemsKomitent[0].Emaili != null){
          for (let i = 0; i < this.itemsKomitent[0].Emaili.length; i++){
            await new Promise<void>((resolve, reject) =>{
              this.itemEmail = new KomitentEmail();
              this.itemEmail.Deserialize(this.itemsKomitent[0].Emaili[i]);
              this.itemEmail.KomitentID = this.itemsKomitent[0].ID;
              this.itemEmail.ID = -1;
              this.baseDataService.Post("KomitentEmail","post",this.itemEmail,null)
                .subscribe(()=>{
                  resolve();
                },
                error =>{
                  this.translateService.get(['KOMITENT.UVOZNBS.INSERTKOMITENTEMAIL.ERROR.TITLE'])
                  .subscribe(translate => {
                    // this.notificationService.warn(translate['KOMITENT.UVOZNBS.INSERTKOMITENTEMAIL.ERROR.TITLE'], error.error + " "+ this.itemEmail.Naziv);
                    this.toastrService.warning(translate['KOMITENT.UVOZNBS.INSERTKOMITENTEMAIL.ERROR.TITLE'], error.error + " "+ this.itemEmail.Naziv);
                  });
                  this.submitted = false;
                  this.loading = false;
                  this.activeModal.close(this.itemsKomitent[0].ID);
                  //return false;
                })
              
            })
          }
        }
        if (this.itemsKomitent[0].Telefoni != null){
          for (let i = 0; i < this.itemsKomitent[0].Telefoni.length; i++){
            await new Promise<void>((resolve, reject) =>{
              this.itemTelefon = new KomitentTelefon();
              this.itemTelefon.Deserialize(this.itemsKomitent[0].Telefoni[i]);
              this.itemTelefon.KomitentID = this.itemsKomitent[0].ID;
              this.itemTelefon.ID = -1;
              this.baseDataService.Post("KomitentTelefon","post",this.itemTelefon,null)
                .subscribe(()=>{
                  resolve();
                },
                error =>{
                  this.translateService.get(['KOMITENT.UVOZNBS.INSERTKOMITENTTELEFON.ERROR.TITLE'])
                  .subscribe(translate => {
                    // this.notificationService.warn(translate['KOMITENT.UVOZNBS.INSERTKOMITENTTELEFON.ERROR.TITLE'], error.error + " "+ this.itemTelefon.Broj);
                    this.toastrService.warning(translate['KOMITENT.UVOZNBS.INSERTKOMITENTTELEFON.ERROR.TITLE'], error.error + " "+ this.itemTelefon.Broj);
                  });
                  this.submitted = false;
                  this.loading = false;
                  this.activeModal.close(this.itemsKomitent[0].ID);
                  //return false;
                })
              
            })
          }
        }
        if (this.itemsKomitent[0].ZiroRacuni != null){
          for (let i = 0; i < this.itemsKomitent[0].ZiroRacuni.length; i++){
            await new Promise<void>((resolve, reject) =>{
              this.itemZrc = new KomitentZrc();  
              // this.itemZrc.Serialize(this.itemsKomitent[0].ZiroRacuni[i]);            
              this.itemZrc.Deserialize(this.itemsKomitent[0].ZiroRacuni[i]);
              this.itemZrc.KomitentID = this.itemsKomitent[0].ID;
              this.itemZrc.ID = -1;
              this.baseDataService.Post("KomitentZrc","post",this.itemZrc,null)
                .subscribe(()=>{
                  resolve();
                },
                error =>{
                  this.translateService.get(['KOMITENT.UVOZNBS.INSERTKOMITENTZRC.ERROR.TITLE'])
                  .subscribe(translate => {
                    // this.notificationService.warn(translate['KOMITENT.UVOZNBS.INSERTKOMITENTZRC.ERROR.TITLE'], error.error + " "+ this.itemZrc.Zrc);
                    this.toastrService.warning(translate['KOMITENT.UVOZNBS.INSERTKOMITENTZRC.ERROR.TITLE'], error.error + " "+ this.itemZrc.Zrc);
                  });
                  this.submitted = false;
                  this.loading = false;
                  this.activeModal.close(this.itemsKomitent[0].ID);
                  //return false;
                })
              
            })
          }
        }
        this.submitted = false;
        this.loading = false;
        this.activeModal.close(this.itemsKomitent[0].ID);
      }
      else{
        this.translateService.get(['KOMITENT.UVOZNBS.VALIDATION.TITLE', 'KOMITENT.UVOZNBS.VALIDATION.CONTENT'])
          .subscribe(translate => {
            // this.notificationService.warn(translate['KOMITENT.UVOZNBS.VALIDATION.TITLE'], translate['KOMITENT.UVOZNBS.VALIDATION.CONTENT']);
            this.toastrService.warning(translate['KOMITENT.UVOZNBS.VALIDATION.TITLE'], translate['KOMITENT.UVOZNBS.VALIDATION.CONTENT']);
          });
      }
    }
    
    
}

checkGridData(items: List<any>, gridTableColumns: any[], mozePrazanItems: boolean):boolean{
  if (items){
    let itemsPropertyName = Object.keys(items[0]);
    let _required:boolean = false;
    let retVal:boolean = true;

    for (let i = 0; i < itemsPropertyName.length; i++){
      for (let j = 0; j < gridTableColumns.length; j++){
        if (itemsPropertyName[i] == gridTableColumns[j]["name"]){
          _required = gridTableColumns[j]["required"] == "true" ? true : false;
          if(_required){
            for (let k = 0; k < items["length"]; k++){
              retVal = true;
              switch(gridTableColumns[j]["type"]){
                case "DDL":
                  if (items[k][itemsPropertyName[i]] == null){
                    retVal = false;
                  }
                  break;
                case "number":
                  if (items[k][itemsPropertyName[i]] == 0){
                    retVal = false;
                  }
                  break;
                case "input":
                  if (items[k][itemsPropertyName[i]] == ""){
                    retVal = false;
                  }
                  break;
              }
              if (retVal == false){
                this.submitted = false;
                this.loading = false;
                return retVal;
              }
            }
          }
        }
      }         

    }
    return retVal;
  }
  else{
    if (mozePrazanItems)
      return true;
    else
      return false;
  } 
}

checkBrojGlavnih(items: List<any>):number{
  let array = Array.from(items);
  let brojGlavnih : number;

  if (items){
    brojGlavnih = array.filter(function(value){
      return value["Glavni"] === true;
  }).length
    
  }
  return brojGlavnih;
}



}
